export const SUPERADMIN = 'superAdmin';
const ADMIN = 'admin';

export { ADMIN };
